export default __webpack_public_path__ + "static/museum-f1398120fe5e9a13e18c1cbac7b0d146.svg";